<adf-upload-drag-area
  (beginUpload)="onBeginUpload($event)"
  [rootFolderId]="currentFolderId"
  [disabled]="!canUpload"
>
  <adf-sidenav-layout
    #layout
    [sidenavMin]="0"
    [sidenavMax]="320"
    [stepOver]="600"
    [hideSidenav]="false"
    [expandedSidenav]="expandedSidenav"
    (expanded)="onExpanded($event)"
  >
    <adf-sidenav-layout-navigation>
      <ng-template let-isMenuMinimized="isMenuMinimized">
        <wk-sidenav
          [data]="layout"
          [mode]="isMenuMinimized() ? 'collapsed' : 'expanded'"
          [attr.data-automation-id]="
            isMenuMinimized() ? 'collapsed' : 'expanded'
          "
          (swipeleft)="hideMenu($event)"
          class="wk-sidenav"
        >
        </wk-sidenav>
      </ng-template>
    </adf-sidenav-layout-navigation>

    <adf-sidenav-layout-content>
      <ng-template>
        <router-outlet></router-outlet>
      </ng-template>
    </adf-sidenav-layout-content>
  </adf-sidenav-layout>

  <adf-file-uploading-dialog position="left"></adf-file-uploading-dialog>
</adf-upload-drag-area>
<wk-ai *ngIf="(appConfigAIEnabled | async)[aiKey]"></wk-ai>